import React, { FC, useState, useEffect, ChangeEvent } from 'react';
import { useTheme } from '../../../theme';
import cn from 'classnames';
import { PassengerFieldOption } from '../../../Passenger/types';
import { CdnIcon } from '@shared/ui';

interface Props {
	options?: PassengerFieldOption[];
	className?: string;
	disabled?: boolean;
	onChange?: (value: string) => void;
	onBlur?: () => void;
	activeSex?: string;
	error?: boolean;
	helperText?: string;
}

const SexSelector: FC<Props> = ({ className, disabled, activeSex, options, onChange, onBlur, error, helperText }) => {
	const { SexSelector: css } = useTheme('BaseComponents');

	const resolvedOptions = options ?? [
		{ key: 'Male', value: 'Male', icon: <CdnIcon className={css.icon} icon="Info/Male" /> },
		{ key: 'Female', value: 'Female', icon: <CdnIcon className={css.icon} icon="Info/Female" /> }
	];

	const [sex, setSex] = useState(activeSex);

	useEffect(() => {
		if (activeSex !== sex) {
			setSex(activeSex);
		}
	}, [activeSex]);

	const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
		setSex(e.target.value);
		onChange?.(e.target.value);
		onBlur?.();
	};

	return (
		<div className={cn(css.sexSelector, className)}>
			<div className={css.sexSelector__container}>
				{resolvedOptions.map(option => (
					<label
						className={cn(css.label, {
							[css.error]: error,
							[css.disabled]: disabled,
							[css.checked]: option.key === sex
						})}
						key={option.key}
					>
						{option.icon && <div className={css.icon}>{option.icon}</div>}

						<input
							id={option.key}
							type="radio"
							className={cn(css.input)}
							checked={option.key === sex}
							value={option.key}
							disabled={disabled}
							onChange={onChangeHandler}
						/>
					</label>
				))}
			</div>
			{error && <div className={css.sexSelector__helperText}>{helperText}</div>}
		</div>
	);
};

export default SexSelector;
